// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInCalendarQuarters/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInCalendarQuarters = convertToFP(fn, 2);
export default differenceInCalendarQuarters;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInCalendarQuarters/index.js
// module id = 831
// module chunks = 0